module.exports = __webpack_public_path__ + "static/img/11.0576402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/11.jpg
// module id = ldLc
// module chunks = 16